/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VolumeType {
    /**
     * Default is undefined
     */ 
    Undefined = 0,
    /**
     * Volume in recording
     */ 
    Rec = 2,
    /**
     * Volume on control pc             
     */ 
    PC = 4,
    /**
     * Volume on player
     */ 
    Broadcast = 8,
    /**
     * Reserve numbers for volume types to come
     */ 
    Any = 256,
}
